import { gql } from '@apollo/client';

export const addClaim = gql`
  mutation addClaim($createClaimInput: CreateClaimInput!) {
    claimManagement {
      createClaim(createClaimInput: $createClaimInput)
    }
  }
`;

export const saveClaimPayments = gql`
  mutation savePayment($savePaymentInput: SavePaymentInput!) {
    claimManagement {
      savePayment(savePaymentInput: $savePaymentInput)
    }
  }
`;

export const markClaimAsPaid = gql`
  mutation markAsPaid($markAsPaidInput: MarkAsPaidInput!) {
    claimManagement {
      markAsPaid(input: $markAsPaidInput)
    }
  }
`;

export const addClaimDocumentMutation = gql`
  mutation addClaimDocument(
    $claimId: String!
    $document: Upload!
    $documentName: String!
  ) {
    claimManagement {
      addClaimDocument(
        claimId: $claimId
        document: $document
        documentName: $documentName
      )
    }
  }
`;


export const rejectClaim = gql`
  mutation rejectClaim($rejectClaimInput: RejectClaimInput!) {
    claimManagement {
      rejectClaim(rejectClaimInput: $rejectClaimInput)
    }
  }
`;

export const approveClaim = gql`
  mutation approveClaim($aprroveClaimInput: ApproveClaimInput!) {
    claimManagement {
      approveClaim(aprroveClaimInput: $aprroveClaimInput)
    }
  }
`;

export const compareEstimationToSumInsured = gql`
  mutation compareEstimationToSumInsured(
    $claimId: String!
    $currencyId: String!
    $estimationAmount: Decimal!
    $sumInsured: Decimal!
  ) {
    claimManagement {
      compareEstimationToSumInsured(
        claimId: $claimId
        currencyId: $currencyId
        estimationAmount: $estimationAmount
        sumInsured: $sumInsured
      )
    }
  }
`;

export const createClaimEstimations = gql`
  mutation createClaimEstimations(
    $createClaimEstimationsInput: CreateClaimEstimationsInput!
  ) {
    claimManagement {
      createClaimEstimations(
        createClaimEstimationsInput: $createClaimEstimationsInput
      )
    }
  }
`;
